module.exports = __webpack_public_path__ + "img/zxjf.dea8304c.png";